import React from 'react';
import ZeventLogo from './ZeventLogo.jsx';
import { Route } from 'react-router-dom';

class ZeventHeader extends React.Component {
	render () {
		return (
			<div>
				<Route path="/:year" component={ZeventLogo}/>
				<h2 
					className="proxima txt-center ptm pbl mbl">
					Quel stream est on ? Quel stream est off ?
					<br className="small-hidden tiny-hidden" />
					<span className="medium-hidden large-hidden">&nbsp;</span>
					Quels jeux streament-ils ?
				</h2>
			</div>
		);
	}
}

export default ZeventHeader;